module.exports = __webpack_public_path__ + "static/img/8.62ac229.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/8.jpg
// module id = t5ol
// module chunks = 0